import { FirebaseOptions } from "@angular/fire/app";
import { EncryptionService } from "../services/encryption.service";

// Función para obtener configuración de Firebase
export function getFirebaseConfig(): FirebaseOptions | null {
  try {
    const encryptionService = new EncryptionService();
    const _window: any = window;

    if (_window.selfPc) {
      const _x = '12345678901234567890123456789012', _y = '1234567890123456';
      const projectConfig = encryptionService.decrypt(_window.selfPc, _x, _y);
      console.log('projectConfig', projectConfig);

      // Si existe la configuración de Firebase en el proyecto
      if (projectConfig?.firebase) {
        return projectConfig.firebase;
      }
    }
    return null;
  } catch (error) {
    // console.error('Error al obtener configuración de Firebase:', error);
    return null;
  }
}
